export const UPLOAD_LIMITS = {
  MAX_IMAGE_UPLOADS: 12,
  MAX_VIDEO_DURATION: 180,
  MAX_FILE_SIZE: 250,
  MAX_FILES: 20,
  HEALTH_MAX_FILES: 5
};

export const FILE_TYPES = {
  IMAGES: "image/png,image/jpeg,image/jpg,image/webp",
  VIDEOS: "video/*",
  ALL_MEDIA: "image/png,image/jpeg,image/jpg,image/webp,video/*",
  HEALTH_ONLY: "image/png,image/jpeg,image/jpg,image/webp"
};

export const UI_STYLES = {
  IMAGE: "object-fit: cover;",
  ORDER_INPUT: "width: 60px; border: none; background: transparent; text-align: center; font-size: 16px; font-weight: bold;",
  DRAG_HANDLE: "position: absolute; top: -10px; z-index: 10;",
  ORDER_CONTAINER: "text-align: center; margin-top: -15px;"
};

export const MESSAGES = {
  UPLOAD_SUCCESS: "Uploaded media successfully",
  UPLOAD_FAILED: "Upload failed",
  DELETE_SUCCESS: "File deleted successfully",
  DELETE_FAILED: "Failed to delete the file",
  MAX_IMAGES_EXCEEDED: (max) => `Failed to upload the file, max ${max} images allowed`,
  VIDEO_TOO_LONG: (maxDuration) => `Video is too long. Please select a video that is ${maxDuration} seconds or less.`,
  NO_ID_RESPONSE: "No ID found in the response",
  YOUTUBE_VIDEO_ALREADY_UPLOADED: "Cannot upload video when YouTube video is already present"
};
